import React, { FormEvent, useState, useEffect } from 'react';
import ReactLoading from 'react-loading';

import { showErrorToast, showSuccessToast } from 'utilities/notificationUtils';
import { CUSTOM_CODE_REGEXP, useRegisterHomeTesting } from './hooks/useRegisterHomeTesting';
import {
  Columns,
  Column,
  Form,
  Input,
  ActivateButton,
  MainHeading,
  SubHeading,
  Description,
  Divider,
  Label
} from './RegisterCustomCode.styles';

const RegisterCustomCode = () => {
  const {
    registerHomeTesting,
    storedRegistrationCode,
    error,
    message,
    loading
  } = useRegisterHomeTesting();
  const [registrationCode, setRegistrationCode] = useState<string>(storedRegistrationCode);

  useEffect(() => {
    if (!message) {
      return;
    }

    showSuccessToast(message);
    setRegistrationCode('');
    if (window.analytics) {
      window.analytics.track('AHT Activation Successful - TRACK');
    }
  }, [message]);

  useEffect(() => {
    if (!error) {
      return;
    }

    showErrorToast(error);
    if (window.analytics) {
      window.analytics.track('AHT Activation Failed - TRACK');
    }
  }, [error]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    registerHomeTesting(registrationCode);
  };

  const onVisitShop = () => {
    if (window.analytics) {
      window.analytics.track('Kindbody Shop Visited - TRACK');
    }
  };

  const onVisitFAQ = () => {
    if (window.analytics) {
      window.analytics.track('AHT FAQ Viewed');
    }
  };

  return (
    <Columns>
      <Column>
        <MainHeading>Did you order an at-home testing kit?</MainHeading>
        <Description>
          Before entering your registration code, please verify your address within your profile. We
          use this information to ensure that we can process your test results per your state's
          regulations. For best results, take the test on days 2, 3 or 4 of your period.
          <a href="/my-profile">Verify address on profile</a>
        </Description>

        <Divider />

        <Form onSubmit={handleSubmit}>
          <Label>Enter your registration code to activate</Label>
          <Input
            type="text"
            disabled={loading}
            onChange={e => setRegistrationCode(e.target.value?.toLocaleUpperCase())}
            value={registrationCode}
            className="input"
          />
          <ActivateButton disabled={!registrationCode.match(CUSTOM_CODE_REGEXP) || loading}>
            {loading ? <ReactLoading type="spin" height={16} width={16} /> : 'Activate'}
          </ActivateButton>
        </Form>
      </Column>
      <Column>
        <SubHeading>Order your lab tests conveniently from your home. </SubHeading>
        <a href="https://shop.kindbody.com" onClick={onVisitShop} target="_blank" rel="noreferrer">
          Visit Kindbody Shop
        </a>
      </Column>
      <Column>
        <SubHeading>Have questions?</SubHeading>
        <a
          href="https://shop.kindbody.com/pages/faq"
          onClick={onVisitFAQ}
          target="_blank"
          rel="noreferrer"
        >
          Visit our FAQ
        </a>
      </Column>
    </Columns>
  );
};

export default RegisterCustomCode;
